function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    props: {
        active: {
            default: true
        }
    },
    data: function data() {
        return {
            headers: ['Send 1099', "Account Number", "Name", "DBA", "Paid Amount", "1099 Amount"],
            fields: ['current_year_1099', "id", "name", "dba_name", "checks_total", 'current_year_1099_amount'],
            items: [],
            checkboxes: ['current_year_1099'],
            show: false,
            adjustAmount: {
                acctId: 0,
                amount: 0
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;
        $el.load(0);
        $el.show = true;

        Event.$on('load-1099-vendor-list', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            $el.load(offset, search, sort, order, isDate);
            $el.show = true;
            Event.$emit('hide-archive-vendor-list');
        });

        Event.$on('hide-vendor-list', function () {
            return _this.show = false;
        });

        Event.$on('overwrite-amount', function (item) {
            _this.adjustAmount.acctId = item.id;
            _this.adjustAmount.amount = item.current_year_1099_amount;
            Event.$emit('show-small-modal');
        });

        Event.$on('export-1099-vendor-list', function () {
            var exportItems = _this.items.filter(function (vendor) {
                return vendor.current_year_1099;
            });

            _this.createExport({ 'data': exportItems }, '/prototype/vendors/exportFor1099s', '1099-vendor-info', '.xlsx');
        });

        Event.$on('delete-vendor', function (item) {
            Event.$emit('confirm-delete', item, '', 'remove-vendor', 'Do you want to archive this vendor?', 'Yes');
        });

        /**
         * serves only to check/uncheck current year's need to print, and store override 1099 amounts
         */
        Event.$on('update-checked-item', this.updateCheckedItem);

        Event.$on('remove-vendor', function (item) {
            var $el = _this;
            axios.delete('/prototype/vendors/' + item.id).then(function () {
                var $idx = $el.items.findIndex(function (i) {
                    return i.account_number === item.account_number;
                });
                $el.items.splice($idx, 1);
            });
        });
    },

    methods: {
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var self = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };

            //uses main vendor list; means "active", "1099 required"
            axios.post('/prototype/vendors/list/1/1', data).then(function (response) {
                offset !== 0 ? self.items = [].concat(_toConsumableArray(self.items), _toConsumableArray(response.data)) : self.items = response.data;

                self.items.map(function (vendor) {
                    if (vendor.contacts.length) {
                        vendor['contact'] = vendor.contacts[0].name;
                    }

                    //marks as checked by default
                    vendor.current_year_1099 = parseFloat(vendor.checks_total.replace(",", "")) >= 600;

                    // if null, nothing was ever stored. if true/false, was set explicitly
                    if (vendor.current_year_1099_flag !== null) {
                        vendor.current_year_1099 = vendor.current_year_1099_flag; //marks as "print"
                    }

                    // if amount has been overwritten, use that. otherwise usual checks total. Excel will use same logic
                    vendor.current_year_1099_amount = vendor.current_year_1099_amount !== null ? vendor.current_year_1099_amount : vendor.checks_total;
                });

                Event.$emit('data-table-loaded');
            });
        },
        additionalAction: function additionalAction(item) {
            return true; //true will show on row; false will hide
        },
        saveOverwriteAmount: function saveOverwriteAmount() {
            var _this2 = this;

            var $el = this;
            var $idx = $el.items.findIndex(function (i) {
                return _this2.adjustAmount.acctId === i.id;
            });
            var item = $el.items[$idx];
            item.current_year_1099_amount = this.adjustAmount.amount;
            this.updateCheckedItem(item);
        },
        updateCheckedItem: function updateCheckedItem(item) {
            var _this3 = this;

            var $el = this;
            var payload = {
                'id': item.id,
                'tax_1099_year': moment().format('YYYY'),
                'tax_1099_print': item.current_year_1099,
                'tax_1099_amount': item.current_year_1099_amount
            };
            axios.put('/prototype/vendors/' + item.id, payload).then(function () {
                var $idx = $el.items.findIndex(function (i) {
                    return i.id === item.id;
                });
                $el.items[$idx] = item;
            }).then(function () {
                var msg = item.current_year_1099 ? 'The Vendor was added to the list to be printed' : 'The Vendor was removed from the list to be printed';
                _this3.$snotify.success(msg);
                Event.$emit('close-small-modal');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/vendors/Vendor1099List.vue
// module id = lquU
// module chunks = 0 1